export const PRIVATE_PAGE_DOCUMENT_TITLE_MAX_NOTIFICATIONS = 99;

export type GetPrivatePageDocumentTitleParams = {
  pageTitle: string | undefined;
  unreadCount: number;
  workspaceName: string | undefined;
};

const getNonEmptyTitle = (value: string | undefined) => {
  const trimmed = value?.trim();

  return trimmed || undefined;
};

export const getPrivatePageDocumentTitle = ({
  pageTitle,
  unreadCount,
  workspaceName,
}: GetPrivatePageDocumentTitleParams) => {
  const title = getNonEmptyTitle(pageTitle) ?? getNonEmptyTitle(workspaceName);

  if (!title) {
    return undefined;
  }

  if (unreadCount <= 0) {
    return title;
  }

  const countToDisplay =
    unreadCount > PRIVATE_PAGE_DOCUMENT_TITLE_MAX_NOTIFICATIONS
      ? `+${PRIVATE_PAGE_DOCUMENT_TITLE_MAX_NOTIFICATIONS}`
      : unreadCount;

  return `(${countToDisplay}) ${title}`;
};
